/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  List,
  ListItem,
  Button,
  useTheme,
  Box,
  Typography,
  Stack,
  Dialog,
  DialogActions,
  DialogContent,
} from "@mui/material";
import { INavbarMenu } from "@/@types/NavbarMenuList";
import { inject, observer } from "mobx-react";
import Store from "@/store";
import { UserStore } from "@/store/user";
export const navbarMenuList: INavbarMenu[] = [
  {
    label: "Home",
    href: "/",
  },
  {
    label: "Trade",
    href: "/trade",
  },
  { label: "My posts", href: "/trade/my-posts" },
  {
    label: "Orders",
    href: "/trade/my-orders",
  },
  {
    label: "Profile",
    href: "/profile",
  },
  {
    label: "Sign out",
    href: "/sign-out",
  },
];
const AuthorizedNavbarMenu = inject(Store.type.userStore)(
  observer((props: any) => {
    const theme = useTheme();
    const location = useLocation();
    const navigate = useNavigate();
    const [openConfirmSignOut, setOpenConfirmSignOut] = React.useState(false);
    const userStore = props[Store.type.userStore] as UserStore;
    const handleCloseConfirmSignOut = () => {
      setOpenConfirmSignOut(false);
      userStore.signOut();
      window.location.href = "/";
      window.location.reload();
    };
    return (
      <>
        <List
          sx={{ display: "flex", padding: 0, margin: 0, listStyle: "none" }}
        >
          {navbarMenuList.map((item) => (
            <>
              <ListItem
                key={item.href}
                sx={{
                  my: "0",
                  p: "0",
                }}
              >
                <Box
                  position="relative"
                  mx="27px"
                  sx={{
                    "&:hover": {
                      ".dropdown-toggle": {
                        display: "block !important",
                      },
                    },
                  }}
                >
                  <Typography
                    onClick={() => {
                      if (item.href === "/sign-out") {
                        setOpenConfirmSignOut(true);
                        return;
                      }
                      if (item.label === "Manual") {
                        window.open(item.href, "_blank");
                        return;
                      }
                      navigate(item.href);
                    }}
                    variant="navBarText"
                    sx={{
                      color:
                        item.href === location.pathname
                          ? theme.colors.blueDark
                          : undefined,
                      fontWeight:
                        item.href === location.pathname ? "700" : undefined,
                      "&:hover": {
                        cursor: "pointer",
                        color: theme.colors.blueDark,
                        fontWeight: "700",
                      },
                    }}
                  >
                    {item.label}
                  </Typography>

                  {item.sub && (
                    <Stack
                      bottom="0"
                      left="50%"
                      className="dropdown-toggle"
                      direction="column"
                      position="absolute"
                      display="none"
                      bgcolor={theme.colors.white}
                      sx={{
                        transform: "translate(-50%,100%)",
                      }}
                    >
                      {item.sub.map((subItem) => (
                        <Button
                          key={subItem.href}
                          onClick={() => {
                            navigate(subItem.href);
                          }}
                          sx={{
                            width: "100%",
                            px: "1rem",
                            py: "0.7rem",
                            whiteSpace: "nowrap",
                            borderRadius: "0",
                            color:
                              subItem.href === location.pathname
                                ? theme.colors.navbarBGColor
                                : theme.colors.black,
                            backgroundColor:
                              subItem.href === location.pathname
                                ? theme.colors.black
                                : theme.colors.navbarBGColor,
                            "&:hover": {
                              color: theme.colors.lightFontColor,
                              bgcolor: theme.colors.black,
                            },
                          }}
                        >
                          {subItem.label}
                        </Button>
                      ))}
                    </Stack>
                  )}
                </Box>
              </ListItem>
            </>
          ))}
        </List>
        <Dialog
          open={openConfirmSignOut}
          onClose={() => setOpenConfirmSignOut(false)}
        >
          <Typography variant="h4">Sign out</Typography>
          <DialogContent>
            <Typography>Are you sure you want to sign out?</Typography>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              size="large"
              onClick={() => setOpenConfirmSignOut(false)}
            >
              No
            </Button>
            <Button
              size="large"
              variant="contained"
              onClick={handleCloseConfirmSignOut}
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }),
);

export default AuthorizedNavbarMenu;
